import { render, staticRenderFns } from "./StyleGuide.vue?vue&type=template&id=1228635f&scoped=true"
import script from "./StyleGuide.vue?vue&type=script&lang=js"
export * from "./StyleGuide.vue?vue&type=script&lang=js"
import style0 from "./StyleGuide.vue?vue&type=style&index=0&id=1228635f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1228635f",
  null
  
)

export default component.exports